export default "__VITE_ASSET__Co$3$AzI__"